<template>
  <form @submit.prevent="update">
    <div class="card border-0 no-shadow bg-light mb-3">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลผู้เรียน</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div v-if="comId != 527" class="form-group col-md-4">
            <label>คำนำหน้า</label>
            <v-select
              :options="prefixList"
              v-model="prefixName"
              @input="edit({ name: 'prefixName', value: prefixName })"
              :clearable="false"
            />
          </div>
          <div class="form-group col-md-4">
            <label>ชื่อ</label>
            <FormInputText
              :name="'firstName'"
              :type="`text`"
              :value="member.firstName"
              :placeholder="`ชื่อ`"
              :errorText="'กรุณากรอกชื่อ'"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-4">
            <label>นามสกุล</label>
            <FormInputText
              :name="'lastName'"
              :type="`text`"
              :value="member.lastName"
              :placeholder="`นามสกุล`"
              :is-editable="true"
              :errorText="'กรุณากรอกนามสกุล'"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
        <template v-if="comId == 527">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label>ชื่อภาษาอังกฤษ</label>
              <FormInputText
                :name="'firstNameEn'"
                :type="`text`"
                :value="member.firstNameEn"
                :placeholder="`ชื่อภาษาอังกฤษ`"
                :errorText="'กรุณากรอกชื่อภาษาอังกฤษ'"
                :errors="errors.firstNameEn != null ? 'กรุณากรอกชื่อภาษาอังกฤษ' : ''"
                :is-editable="true"
                @edited="edit"
              ></FormInputText>
            </div>
            <div class="form-group col-md-4">
              <label>นามสกุลภาษาอังกฤษ</label>
              <FormInputText
                :name="'lastNameEn'"
                :type="`text`"
                :value="member.lastNameEn"
                :placeholder="`นามสกุลภาษาอังกฤษ`"
                :is-editable="true"
                :errorText="'กรุณากรอกนามสกุลภาษาอังกฤษ'"
                :errors="errors.lastNameEn != null ? 'กรุณากรอกนามสกุลภาษาอังกฤษ' : ''"
                @edited="edit"
              ></FormInputText>
            </div>
          </div>
        </template>
        <div v-if="!isTutorType() || comId == 525" class="form-row">
          <div class="form-group col-md-4">
            <label>เลขประจำตัวประชาชน</label>
            <FormInputText
              :name="'idCard'"
              :type="`text`"
              :value="member.idCard"
              :placeholder="`เลขประจำตัวประชาชน`"
              :errorText="'กรุณากรอกเลขประจำตัวประชาชน'"              
              :errors="errors.idCard != null ? 'กรุณากรอกเลขประจำตัวประชาชน 13 หลัก' : ''"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-4">
            <label>วันหมดอายุบัตรประชาชน</label>
            <FormInputText
              :name="'idCardExpireDate'"
              :type="`date`"
              :value="member.idCardExpireDate"
              :placeholder="`dd/mm/yyyy`"
              :is-editable="true"
              :errorText="'กรุณากรอกวันหมดอายุบัตรประชาชน'"
              @edited="edit"
            ></FormInputText>
            <b-form-checkbox
              name="isNotExpired"
              v-model="isNotExpired"
              @change="checkedNotExpired"
            >
              บัตรประชาชนตลอดชีพ
            </b-form-checkbox>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>วันเดือนปีเกิด</label>
            <FormInputText
              :name="'dateOfBirth'"
              :type="`date`"
              :value="member.dateOfBirth"
              :placeholder="`dd/mm/yyyy`"
              :maxDate="today"
              :is-editable="true"
              :errorText="'กรุณากรอกวันเดือนปีเกิด'"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-md-4">
            <label>เบอร์โทรศัพท์</label>
            <FormInputText
              :name="'phoneNumber'"
              :type="`text`"
              :value="member.phoneNumber"
              :placeholder="`0999999999`"
              :is-editable="true"
              :max="'15'"
              :errorText="'กรุณากรอกเบอร์โทรศัพท์'"
              :errors="errors.phoneNumber != null ? 'กรุณากรอกเบอร์โทรศัพท์' : ''"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
        <template v-if="comId == 525">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label>ระดับการศึกษา</label>
              <v-select
                :options="educationLevelList"
                label="label"
                :reduce="option => option.value"
                v-model="selectedEducationLevel"
                @input="onEducationLevelChange"
                :clearable="false"
              />
              <input
                v-if="selectedEducationLevel === 'OTHER'"
                type="text"
                class="form-control"
                v-model="customEducationLevel"
                @change="onCustomEducationLevelInput"
                style="margin-top: 10px;"
                required
              />
            </div>
            <div class="form-group col-md-4">
              <label>หน่วยงาน</label>
              <v-select
                :options="companyList"
                label="label"
                :reduce="option => option.value"
                v-model="selectedCompany"
                :clearable="false"
                @input="onCompanyChange"
              />
              <input
                v-if="selectedCompany === 'other'"
                type="text"
                class="form-control"
                v-model="customCompany"
                @change="onCustomCompanyInput"
                style="margin-top: 10px;"
                required
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label>กลุ่มอุตสาหกรรม</label>
              <v-select
                :options="departmentList"
                label="label"
                :reduce="option => option.value"
                v-model="selectedDepartment"
                :clearable="false"
                @input="onDepartmentChange"
              />
              <input
                v-if="selectedDepartment === 'other'"
                type="text"
                class="form-control"
                v-model="customDepartment"
                @change="onCustomDepartmentInput"
                style="margin-top: 10px;"
                required
              />
            </div>
          </div>
        </template>
        <template v-if="isTutorType()">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label>โรงเรียน</label>
              <FormInputText
                :name="'education'"
                :type="`text`"
                :value="member.education"
                :placeholder="``"
                :is-editable="true"
                :errorText="'กรุณากรอกโรงเรียน'"
                :errors="errors.education != null ? 'กรุณากรอกโรงเรียน' : ''"
                @edited="edit"
              ></FormInputText>
            </div>
            <div class="form-group col-md-4">
              <label>คณะที่อยากเข้า</label>
              <FormInputText
                :name="'preferredFaculty'"
                :type="`text`"
                :value="member.preferredFaculty"
                :placeholder="``"
                :is-editable="true"
                :errorText="'กรุณากรอกคณะที่อยากเข้า'"
                :errors="errors.preferredFaculty != null ? 'กรุณากรอกคณะที่อยากเข้า' : ''"
                @edited="edit"
              ></FormInputText>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-8">
              <label>มหาวิทยาลัยที่อยากเข้า</label>
              <FormInputText
                :name="'preferredUniversity'"
                :type="`text`"
                :value="member.preferredUniversity"
                :placeholder="``"
                :is-editable="true"
                :errorText="'กรุณากรอกมหาวิทยาลัยที่อยากเข้า'"
                :errors="errors.preferredUniversity != null ? 'กรุณากรอกมหาวิทยาลัยที่อยากเข้า' : ''"
                @edited="edit"
              ></FormInputText>
            </div>
          </div>
        </template>
        <b-row>
          <b-col>
            <TextareaForm
              name="about"
              :value="member.about"
              :is-editable="true"
              label="เกี่ยวกับผู้เรียน"
              class="mb-3"
              placeholder="เกี่ยวกับผู้เรียน"
              @edited="edit"
            />
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="!(isTutorType()|| isInsuranceType() || isAccountingType())" class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลพนักงาน</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>รหัสพนักงาน</label>
            <FormInputText
              :name="'staffId'"
              :type="`text`"
              :value="member.staffId"
              :placeholder="`รหัสพนักงาน`"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>

          <div class="form-group col-md-8">
            <label>แผนก</label>
            <FormInputText
              :name="'department'"
              :type="`text`"
              :value="member.department"
              :placeholder="`แผนก`"
              :is-editable="true"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
      </div>
    </div>

    <div class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลที่อยู่</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div class="form-group col-md-12">
            <TextareaForm
              name="address"
              :value="member.address"
              :is-editable="true"
              class="mb-3"
              label="ที่อยู่ (บ้านเลขที่ หมู่บ้าน ซอย ถนน)"
              placeholder="ที่อยู่"
              @edited="edit"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 class="card-title">ข้อมูลผู้ใช้งาน</h5>
      </div>
      <div class="card-body pb-0">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>อีเมล</label>
            <FormInputText
              :name="'email'"
              :type="`email`"
              :value="member.email"
              :placeholder="`อีเมล`"
              :is-editable="true"
              :errorText="'กรุณากรอกอีเมล'"
              :errors="emailErrorMessage"
              @edited="edit"
            ></FormInputText>
          </div>
          <div class="form-group col-sm-12 col-md-4">
            <label>ชื่อผู้ใช้งาน</label>
            <FormInputText
              :name="'username'"
              :type="`text`"
              :value="member.username"
              :placeholder="`ชื่อผู้ใช้`"
              :is-editable="true"
              :errorText="'กรุณากรอกชื่อผู้ใช้งาน'"
              :errors="usernameErrorMessage"
              @edited="edit"
            ></FormInputText>
          </div>
        </div>
      </div>
    </div>

    <div class="card border-0 bg-light mb-3 no-shadow">
      <div class="card-header border-0 bg-transparent">
        <h5 v-b-toggle.collapse-change-password class="card-title">
          เปลี่ยนรหัสผ่าน
          <b-icon-chevron-compact-down class="float-right" />
        </h5>
      </div>
      <b-collapse id="collapse-change-password">
        <div class="card-body pb-0">
          <change-password-form
            :errors="errors"
            :isSetPassword="null"
            :isSetConfirmPassword="null"
            @passwordConfirmed="changePassword"
          ></change-password-form>
        </div>
      </b-collapse>
    </div>
  </form>
</template>

<script>
import FormInputText from "./FormInputText";
import ChangePasswordForm from "./ChangePasswordForm";
import TextareaForm from "./TextareaForm";
import authMixin from "@/mixins/auth-mixin.js";
import moment from "moment";
import vSelect from "vue-select";
import { prefixNameList } from "@/helpers/prefix-name";

export default {
  components: { FormInputText, ChangePasswordForm, TextareaForm, vSelect },
  props: {
    member: { type: Object, default: null },
    errors: { type: Object, default: null },
  },
  mixins: [authMixin],
  data() {
    return {
      memberId: this.$route.params.id,
      comId: this.$store.state.Company.companyInfo.id,
      temp: [],
      userFaceUploadingStatus: false,
      faceFrontImage: null,
      faceLeftImage: null,
      faceRightImage: null,
      faceUpImage: null,
      faceDownImage: null,
      isNotExpired: false,
      prefixName: "",
      prefixList: [],
      selectedEducationLevel: '',
      customEducationLevel: '',
      educationLevelList: [
        { label: 'ประถมศึกษา', value: 'ELEMENTARY' },
        { label: 'มัธยมศึกษาตอนต้น', value: 'LOWER_SECONDARY' },
        { label: 'มัธยมศึกษาตอนปลาย หรือ ปวช.', value: 'UPPER_SECONDARY' },
        { label: 'อนุปริญญา หรือ ปวส.', value: 'DIPLOMA' },
        { label: 'ปริญญาตรี', value: 'BACHELOR' },
        { label: 'ปริญญาโท', value: 'MASTER' },
        { label: 'ปริญญาเอก', value: 'DOCTOR' },
        { label: 'อื่น ๆ (โปรดระบุ)', value: 'OTHER' },
      ],
      selectedCompany: '',
      customCompany: '',
      companyList: [
        { label: 'ภาครัฐ', value: 'ภาครัฐ' },
        { label: 'ภาคเอกชน', value: 'ภาคเอกชน' },
        { label: 'อื่น ๆ (โปรดระบุ)', value: 'other' },
      ],
      selectedDepartment: '',
      customDepartment: '',
      departmentList: [
        { label: 'ด้านความมั่นคงภาครัฐ', value: 'ด้านความมั่นคงภาครัฐ' },
        { label: 'ด้านบริการภาครัฐที่สำคัญ', value: 'ด้านบริการภาครัฐที่สำคัญ' },
        { label: 'ด้านเทคโนโลยีสารสนเทศและโทรคมนาคม', value: 'ด้านเทคโนโลยีสารสนเทศและโทรคมนาคม' },
        { label: 'ด้านการขนส่งและโลจิสติกส์', value: 'ด้านการขนส่งและโลจิสติกส์' },
        { label: 'ด้านพลังงานและสาธารณูปโภค', value: 'ด้านพลังงานและสาธารณูปโภค' },
        { label: 'ด้านสาธารณสุข', value: 'ด้านสาธารณสุข' },
        { label: 'ด้านการศึกษา', value: 'ด้านการศึกษา' },
        { label: 'ด้านการเงิน การลงทุน และการประกัน', value: 'ด้านการเงิน การลงทุน และการประกัน' },
        { label: 'ด้านการท่องเที่ยว', value: 'ด้านการท่องเที่ยว' },
        { label: 'ด้านการค้าส่ง-ค้าปลีก และการค้าออนไลน์', value: 'ด้านการค้าส่ง-ค้าปลีก และการค้าออนไลน์' },
        { label: 'ด้านอสังหาริมทรัพย์', value: 'ด้านอสังหาริมทรัพย์' },
        { label: 'อื่น ๆ (โปรดระบุ)', value: 'other' },
      ],
    };
  },

  computed: {
    today() {
      return new Date().toISOString().split("T")[0];
    },
    getUserFaceUploadingStatus() {
      if (this.userFaceUploadingStatus) {
        return true;
      } else {
        if (
          this.faceFrontImage &&
          this.faceLeftImage &&
          this.faceRightImage &&
          this.faceUpImage &&
          this.faceDownImage
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    emailErrorMessage() {
      if (this.errors.email != null) {
        if (this.errors.email[0].includes('booked')) {
          return 'อีเมล นี้ถูกจองไว้แล้ว กรุณาติดต่อผู้ดูแลระบบเพื่อสอบถามข้อมูลเพิ่มเติม';
        }
        if (this.errors.email[0].includes('registered')) {
          return 'อีเมลนี้ถูกใช้ไปแล้ว กรุณาใช้อีเมลอื่น';
        }
        if (this.errors.email[0].includes('required')) {
          return 'กรุณากรอกอีเมล';
        }
        return 'กรุณากรอกรูปแบบอีเมลให้ถูกต้อง ตัวอย่าง example@mail.com';
      }
      return '';
    },
    usernameErrorMessage() {
      if (this.errors.username != null) {
        if (this.errors.username[0].includes('booked')) {
          return 'ชื่อผู้ใช้งาน นี้ถูกจองไว้แล้ว กรุณาติดต่อผู้ดูแลระบบเพื่อสอบถามข้อมูลเพิ่มเติม';
        }
        if (this.errors.username[0].includes('registered')) {
          return 'ชื่อผู้ใช้งานนี้ถูกใช้ไปแล้ว กรุณาใช้อีเมลอื่น';
        }
        return 'กรุณากรอกชื่อผู้ใช้งาน';
      }
      return '';
    },

    finalEducationLevel() {
      if (this.selectedEducationLevel === 'OTHER') {
        return this.customEducationLevel
          ? `OTHER:${this.customEducationLevel}`
          : '';
      }
      return this.selectedEducationLevel;
    }
  },
  watch: {
    "member.idCardExpireDate"(newVal) {
      if (newVal) {
        this.isNotExpired = newVal === "9999-12-31";
      }
    },
    "member.prefixName"(newVal) {
      newVal ? (this.prefixName = newVal) : (this.prefixName = "-");
    },
    'member.educationLevel'(newVal) {
      if (newVal) {
        this.resolveEducationLevel();
      }
    },
    'member.organization'(newVal) {
      if (newVal) {
        this.resolveCompany();
      }
    },
    'member.department'(newVal) {
      if (newVal) {
        this.resolveDepartment();
      }
    },
  },
  mounted() {
    this.temp = this.member;
    this.prefixList = prefixNameList();

    this.resolveEducationLevel();
    this.resolveCompany();
    this.resolveDepartment();
  },

  methods: {
    resolveEducationLevel() {
      let level = this.member?.educationLevel;

      if (!level) {
        this.selectedEducationLevel = '';
        this.customEducationLevel = '';
        return;
      }

      while (level.startsWith('OTHER:')) {
        level = level.substring('OTHER:'.length);
      }

      const found = this.educationLevelList.find(option => option.value === level);

      if (found) {
        this.selectedEducationLevel = found.value;
        this.customEducationLevel = '';
      } else {
        this.selectedEducationLevel = 'OTHER';
        this.customEducationLevel = level;
      }
    },

    resolveCompany() {
      const value = this.member['organization'];
      if (!value) {
        this.selectedCompany = '';
        this.customCompany = '';
        return;
      }

      const found = this.companyList.find(option => option.value === value);

      if (found) {
        this.selectedCompany = found.value;
        this.customCompany = '';
      } else {
        this.selectedCompany = 'other';
        this.customCompany = value;
      }
    },

    resolveDepartment() {
      const value = this.member['department'];
      if (!value) {
        this.selectedDepartment = '';
        this.customDepartment = '';
        return;
      }

      const found = this.departmentList.find(option => option.value === value);

      if (found) {
        this.selectedDepartment = found.value;
        this.customDepartment = '';
      } else {
        this.selectedDepartment = 'other';
        this.customDepartment = value;
      }
    },

    checkedNotExpired() {
      if (this.isNotExpired) {
        this.member["idCardExpireDate"] = "9999-12-31";
      } else {
        this.member["idCardExpireDate"] = moment().format("YYYY-MM-DD");
      }
      this.patch({ name: 'idCardExpireDate', value: this.member["idCardExpireDate"] });
    },
    edit(input) {
      this.member[input.name] = input.value;
      this.errors[input.name] = null;
      this.patch(input);
    },

    onEducationLevelChange(value) {
      if (value === 'OTHER') {
        this.customEducationLevel = '';
        this.edit({ name: 'educationLevel', value: '' });
      } else {
        this.customEducationLevel = '';
        this.edit({ name: 'educationLevel', value });
      }
    },

    onCustomEducationLevelInput() {
      const value = this.customEducationLevel
        ? `OTHER:${this.customEducationLevel}`
        : '';
      this.edit({ name: 'educationLevel', value });
    },

    onCompanyChange(value) {
      if (value === 'other') {
        this.customCompany = '';
        this.edit({ name: 'organization', value: '' });
      } else {
        this.customCompany = '';
        this.edit({ name: 'organization', value });
      }
    },

    onCustomCompanyInput() {
      const value = this.customCompany
        ? `${this.customCompany}`
        : '';
      this.edit({ name: 'organization', value });
    },

    onDepartmentChange(value) {
      if (value === 'other') {
        this.customDepartment = '';
        this.edit({ name: 'department', value: '' });
      } else {
        this.customDepartment = '';
        this.edit({ name: 'department', value });
      }
    },

    onCustomDepartmentInput() {
      const value = this.customDepartment
        ? `${this.customDepartment}`
        : '';
      this.edit({ name: 'department', value });
    },

    changePassword(data) {
      this.$emit("passwordChanged", data);
    },

    patch(input) {
      this.$emit("patched", input);
      this.isUpdated = true;
    },
  },
};
</script>
